import React,{useState,useEffect} from 'react';
import "./UserSignIn.css";
import VerifyAccount from "../VerifyAccount/VerifyAccount";
import CreateProfile from "../CreateProfile/CreateProfile";
import SignIn from "../SignIn/SignIn"
// import { setUserId } from '../../redux/userSlice';
import {  useNavigate } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
import { resolveLandingPath } from '../../common/landing';
import { clearSession, getUserId, hasValidSession } from '../../auth/session';

export default function UserSignIn() {

  // const dispatch = useDispatch();
  const navigate = useNavigate();
 
  // Redirect to the bookings page if the guest is already signed in
  useEffect(() => {

    let active = true;

    if (hasValidSession()) {
      // A returning session lands the same way a fresh login does: straight into the
      // guest's booking when there is exactly one live one, otherwise the list.
      resolveLandingPath(getUserId()).then((path) => {
        if (active) {
          navigate(path);
        }
      });
    } else {
      // This is the sign in page itself, so there is nowhere to send them:
      // drop whatever stale scraps are left and let the OTP steps render.
      clearSession();
    }

    return () => {
      active = false;
    };
  }, [navigate]);
  



  // State to keep track of the current step
  const [step, setStep] = useState(1);


  // setting contact
  const [contact, setContact] = useState('');


  // setting userId,iscontactVerified
  const [userId, setuserId] = useState('');
  const [is_contact_verified,setisContactVerified] = useState(false);


  // Function to move to the next step
  const handleNextStep = (contactNumber) => {
    setContact(contactNumber);
    setStep(step + 1);
  };

  const handleStepCreateProfile = (Id,verified) => {

    setuserId(Id);
    setisContactVerified(verified);
    setStep(step + 1);

  }

  const handlePreviousStep = ()=>{
    setStep(step - 1);
  }
  

  
  return (
    <>
      {/* Render components conditionally based on the step */}
      {step === 1 && (
        <VerifyAccount  onNextStep={handleNextStep}  />
        
      )}

      {step === 2 && (
        <CreateProfile contact={contact} onNextStep={handleStepCreateProfile} onPrevStep = {handlePreviousStep}  />
      )}

      {
        step===3 && (
          <SignIn userId={userId} is_contact_verified={is_contact_verified} contact={contact}  />
        )
      }


    </>
  )
}
